import { throttle } from "lodash";
import { getSelectedPostType } from "./post-type-cookie";

declare const jQuery: any;
const $ = jQuery;

export function initSpecialBanner(): void
{
    const $banner = $(".hs-special-banner");
    if ($banner.length === 0)
    {
        return;
    }
    
    const $footers = $banner.find(`.footer`);
    if ($footers.length === 0)
    {
        return;
    }

    if ($footers.length === 1)
    {
        const postType: "product"|"supplier" = getSelectedPostType();
        $footers.filter(`.${postType}`).addClass("show");
        return;
    }
    
    const showCorrectFooter = () => {
        const $currFooter = $footers.filter(`.show`);
        const currHeight: number = $currFooter.outerHeight() || 0;
        const postType: "product"|"supplier" = getSelectedPostType();
        $footers.css({ height: "" }).removeClass("show").filter(`.${postType}`).addClass("show");
        const $newFooter = $footers.filter(`.show`);
        if (currHeight && ($newFooter.outerHeight() < currHeight))
        {
            $newFooter.css({ height: currHeight });
        }
    };

    showCorrectFooter();

    const initialHeightFix = () => {
        let maxHeight: number = 0;
        $footers.each(function () {
            const $footer = $(this);
            const showing: boolean = $footer.hasClass("show");
            const h: number = $footer.css({ visibility: "hidden", position: "absolute" }).addClass("show").outerHeight();
            if (!showing)
            {
                $footer.removeClass("show");
            }
            $footer.css({ visibility: "", position: "" });
            if (h && (h > maxHeight))
            {
                maxHeight = h;
            }
        });
        if (maxHeight)
        {
            $footers.css({ height: maxHeight });
        }
    };
    
    $(window).on("resize", throttle(() => {
        $footers.css({ height: "" });
    }, 80, { trailing: true })).on("load", initialHeightFix);

    $(document).on("posttypechanged", showCorrectFooter);
}
